import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  List,
  RecaptchaWrapper,
  Recaptcha,
  Wrapper
} from './styled';
import {
  OptionChannel,
  ChannelsPublicationShimmer,
  fetchTypePublication,
  TypePublicationModel,
  setPrintData,
  fetchPrint,
  clearPrintSummaryId,
  FormActions,
  clearExtrachargeAll,
  selectExtracharge
} from '@app/src/views/StepTwo/channelPublication';
import { ModalErrorFeature } from '@app/src/common/modalError';
import { isClientEnv } from '@app/src/utils/validations';
import { CATEGORIES, CATEGORY_ID } from '@app/src/config/categories';
import { Title } from '@app/src/common/Title';
import { cleanAllDateSelected } from '@app/src/common/datePicker/state/calendar/actions';
import { configCalendarId, newspaperIdGroup } from './constants';
import { formatPrice } from '@app/src/utils/normalize';
import { OptionChannelSummary } from '@app/src/views/StepTwo/channelPublication/components/OptionChannelSummary';
import { fetchFreeExtracharge, clearPriceTotal } from '@app/src/views/StepOne/form';

const isClient = isClientEnv();
const EXTRA_WORD_ALIAS = 'palabra-extra';

export const ChannelsPublication: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const publications = useSelector(state => state.typePublication.data);
  const isFetching = useSelector(state => state.typePublication.isFetching);
  const error = useSelector(state => state.typePublication.error);
  const printData = useSelector(state => state.print);
  const printsByChannel = useSelector(state => state.print.printsByChannel);
  const summaryId = useSelector(state => state.print.summaryId);
  const [isNextStep, setIsNextStep] = useState(false);
  const recatpchaKey = process.env.API_KEY_RECAPTCHA;
  const [token, setToken] = useState('');
  const recaptchaRef = useRef(null);
  const print = isClient && JSON.parse(sessionStorage.getItem('print'));
  const [publicationTitle, setPublicationTitle] = useState([]);
  const getAliasCategory = () => location.pathname.split('-')[2];
  const categoryConfig = CATEGORIES[getAliasCategory()];
  const extracharge = useSelector(state => state.extracharge.data);
  const photoVignette = useSelector(state => state.photoVignette.data);
  const [isShowChannels, setIsShowChannels] = useState(true);
  const [currentNewspaper, setCurrentNewspaper] = useState(null);
  const printIsLoading = useSelector(state => state.print.isFetching);
  const priceTotal = useSelector(state => state.priceTotal);
  const priceTotalData = useSelector(state => state.priceTotal.data);
  const [extraSelected, setExtraSelected] = useState(null);
  const [priceSelected, setPriceSelected] = useState(null);

  useEffect(() => {
    if (print && print.general && categoryConfig && print.general.category === categoryConfig.id && print.general.operation) {
      const { operation, property, section, category, typeVehicle } = print.general;
        dispatch(setPrintData(print));
        setExtraSelected(print.extracharges);
        if (print && print.priceTotal && print.priceTotal.data) {
          setPriceSelected(print.priceTotal.data);
        }
        dispatch(fetchFreeExtracharge(category));
        switch(category) {
          case CATEGORY_ID.INMUEBLE:
            dispatch(fetchTypePublication(category, operation, property));
            break;
          case CATEGORY_ID.EMPLEO:
            dispatch(fetchTypePublication(category));
            break;
          case CATEGORY_ID.EDUCACION:
            dispatch(fetchTypePublication(category, operation));
            break;
          case CATEGORY_ID.OPORTUNIDAD:
            dispatch(fetchTypePublication(category, operation, section));
          break;
          case CATEGORY_ID.VEHICULO:
            dispatch(fetchTypePublication(category, operation, typeVehicle));
          break;
          default:
            break;
        }
    } else {
      dispatch(cleanAllDateSelected());
      sessionStorage.setItem('print', JSON.stringify({general: {category: categoryConfig.id}}));
      history.push(`${categoryConfig.link}-1`);
    }
  }, []);

  useEffect(() => {
    if (priceTotalData && Object.keys(priceTotalData).length > 0) {
      setPriceSelected(priceTotalData);
    }
  }, [priceTotalData]);

  useEffect(() => {
    if (extracharge && Object.keys(extracharge).length > 0) {
      setExtraSelected(extracharge);
    }
  }, [extracharge]);

  useEffect(() => {
    if (print && !isNotAnyPrint(printsByChannel) && isClient) {
      window.addEventListener('beforeunload', handleBeforeUnload);
      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
      }
    }
  }, [printsByChannel]);

  const handleBeforeUnload = (e) => {
    const newPrint = {...printData};
    newPrint['printsByChannel'] = {};
    newPrint['summaryId'] = '';
    newPrint['token'] = '';
    newPrint['extracharges'] = {};
    newPrint['priceTotal'] = {};
    newPrint['photoVignette'] = {};
    isClient && sessionStorage.setItem('print', JSON.stringify(newPrint));
    e.returnValue = '¿Desea descartar cambios?';
  };

  const handleClickNext = useCallback(async () => {
    if (isShowChannels) {
      updateDatalayer();
      printData['extracharges'] = {...extracharge};
      printData['priceTotal'] = {...priceTotal};
      printData['photoVignette'] = {...photoVignette};
      recaptchaRef.current.execute();
      setIsNextStep(true);
      isClient && sessionStorage.setItem('print', JSON.stringify(printData));
    } else {
      if (!isNotAnyPrint(printsByChannel)) {
        setIsShowChannels(true);
      }
    }
  }, [publicationTitle, printsByChannel, publications, isShowChannels]);

  const updateDatalayer = () => {
    const selecteds = publicationTitle.join(', ');
    pushDatalayer(categoryConfig.name, selecteds);
    Object.keys(printsByChannel).forEach(key => {
      const channel = publications[key];
      pushDatalayerPayment(categoryConfig.name,key, channel);
    });
  };

  useEffect(() => {
    if (token) {
      dispatch(fetchPrint(printData.general.category, printData, token));
      setToken('');
    }
  }, [token]);

  useEffect(() => {
    if (summaryId && isNextStep) {
      history.push(`${categoryConfig.link}-3/${summaryId}`);
      dispatch(clearPrintSummaryId());
    }
  }, [summaryId, isNextStep, categoryConfig]);

  const isNotAnyPrint = (printsByChannel) => {
    let isNotPrint = true;
    let channelsId = printsByChannel && Object.keys(printsByChannel);
    if (channelsId && channelsId.length > 0) {
      channelsId.forEach((key) => {
        isNotPrint = isNotPrint && (printsByChannel[key].length === 0)
      })
    }
    return isNotPrint;
  }

  const handleClickItem = (idNewspaper) => {
    setIsShowChannels(false);
    setCurrentNewspaper(idNewspaper);
  };

  const handleClickToggleCalendar = (data) => {
    if (data && data.printDate && data.printDate.length === 0) {
      setIsShowChannels(true);
    }
  }

  const setSelectExtraWord = (idChannel) => {
    if (extracharge && extracharge[idChannel] && extracharge[idChannel].data && extracharge[idChannel].data.length > 0) {
      const position = extracharge[idChannel].data.map((item) => { return item.alias; }).indexOf(EXTRA_WORD_ALIAS);
      if (position >= 0 && print && print.general && print.general.extraWords) {
        dispatch(selectExtracharge(idChannel, position, true));
      }
    }
  }

  const handleClickOptionDay = (publicationData, publicationDay, idChannel) => {
    setSelectExtraWord(idChannel);
    const currentTitle = `Clasificados ${publicationData} ${publicationDay}`;
    let isRepeat = false;
    for (let i = 0; i < publicationTitle.length; i++) {
      if (publicationTitle[i] === currentTitle) {
        isRepeat = true;
        break;
      }
    }
    if (publicationTitle.length === 0 || !isRepeat) {
      setPublicationTitle([...publicationTitle, currentTitle]);
    }
  };

  const pushDatalayer = (categoryName: string, publicationName: string) => {
    if (isClient && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        'event': 'EVClasificados',
        'eventCategory': 'Posting',
        'eventAction': `Paso 2.a - ${categoryName}`,
        'eventLabel': publicationName,
        'eventValue': 1
      })
    }
  };

  const pushDatalayerPayment = (categoryName: string, idPublication: string, channel) => {
    const printsTotal = printsByChannel[idPublication].length;
    if (isClient && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        'event': 'EVClasificados',
        'eventCategory': 'Posting',
        'eventAction': `Paso 2 - ${categoryName}`,
        'eventLabel': `Clasificados ${channel.name} ${channel.publicationDay}|${printsTotal}|S/ ${channel.price*printsTotal}`,
        'eventValue': 1
      })
    }
  };

  const handleClickBack = (e) => {
    e.preventDefault();
    if (!isNotAnyPrint(printsByChannel)) {
      const isDiscard = confirm('¿Desea descartar cambios?');
      if (isDiscard) {
        dispatch(clearExtrachargeAll());
        dispatch(cleanAllDateSelected());
        dispatch(clearPriceTotal());
        delete printData.printsByChannel;
        isClient && sessionStorage.setItem('print', JSON.stringify(printData));
        history.push(`${categoryConfig.link}-1`);
      }
    } else {
      isClient && sessionStorage.setItem('print', JSON.stringify(printData));
      history.push(`${categoryConfig.link}-1`);
    }
  };

  const filterByChannelUnique = (publications) => {
    const currentData = Object.values(publications);
    if (currentData && currentData.length > 0) {
      const arrayUniqueByKey = [...new Map(currentData.map(item =>
        [item['newspaperId'], item])).values()]
      return arrayUniqueByKey;
    }
  };

  const filterByChannel = (publications) => {
    const channelData = Object.values(publications);
    return channelData.filter(item => item['newspaperId'] === currentNewspaper);
  };

  const getPriceByNewspaper = useCallback((idNewspaper) => {
    const obj = {1:0, 2:0, 3:0}
    Object.keys(priceSelected).map(key => {
      newspaperIdGroup.map(id => {
        if (configCalendarId[key] && configCalendarId[key].groupId === id) {
          obj[id] = obj[id] + priceSelected[key].price
        }
      })
    });
    return formatPrice(obj[idNewspaper]);
  }, [priceSelected]);

  const getPrintsByNewspaperId = (printsByChannel, id) => {
    const obj = {1:[], 2:[], 3:[]}
    Object.keys(printsByChannel).map(key => {
      newspaperIdGroup.map(id => {
        if (configCalendarId[key] && configCalendarId[key].groupId === id) {
          obj[id] = [
            ...obj[id],
            ...printsByChannel[key]
          ];
        }
      })
    });
    return obj[id];
  };

  const getExtraByNewspaperId = (extracharge, id) => {
    const obj = {1:[], 2:[], 3:[]}
    Object.keys(extracharge).map(key => {
      newspaperIdGroup.map(id => {
        if (extracharge && configCalendarId[key] && configCalendarId[key].groupId === id && extracharge[key].data) {
          obj[id] = [
            ...obj[id],
            ...extracharge[key].data
          ];
        }
      })
    });
    return obj[id].filter(item => (item.checked === true));
  };

  return(
    <Wrapper>
      <Title>¿Dónde quieres publicar?</Title>
      <List>
        {
          (isFetching || error) ?
            <ChannelsPublicationShimmer />
          :
            isShowChannels && publications && Object.keys(publications).length > 0 && filterByChannelUnique(publications) &&
            filterByChannelUnique(publications).map((channel: TypePublicationModel, key) => {
              return(
                <React.Fragment key={key}>
                  <OptionChannelSummary
                    key={key}
                    idNewspaper={channel.newspaperId}
                    title={channel.name}
                    priceIgv={channel.priceIgv}
                    details={printsByChannel && getPrintsByNewspaperId(printsByChannel, channel.newspaperId)}
                    handleClickItem={() => handleClickItem(channel.newspaperId)}
                    priceSubTotal={priceSelected && getPriceByNewspaper(channel.newspaperId)}
                    extrachargeSelected={extraSelected && getExtraByNewspaperId(extraSelected, channel.newspaperId)}
                  />
                </React.Fragment>
            )})
        }
        {
            !isShowChannels && publications && Object.keys(publications).length > 0 && filterByChannel(publications) &&
            filterByChannel(publications).map((channel: TypePublicationModel, key) => {
              return(
                <OptionChannel
                  key={key}
                  idChannel={channel.id}
                  idPackage={channel.packageId}
                  title={channel.name}
                  day={channel.publicationDay}
                  priceIgv={channel.priceIgv}
                  price={channel.price}
                  details={printsByChannel && printsByChannel[channel.id]}
                  printData={channel}
                  isCalendar={true}
                  handleClickItem={() => handleClickOptionDay(channel.name, channel.publicationDay, channel.id)}
                  priceSubTotal={formatPrice(priceTotalData && priceTotalData[channel.id] && priceTotalData[channel.id].price)}
                  extra={extracharge}
                  handleClickToggleCalendar={handleClickToggleCalendar}
                />
            )})
        }
      </List>
      <RecaptchaWrapper>
        <Recaptcha
          ref={recaptchaRef}
          sitekey={recatpchaKey}
          size='invisible'
          badge='inline'
          onChange={ token => setToken(token)}
        />
      </RecaptchaWrapper>
      <FormActions
        textButtonBack={'Datos del aviso'}
        handleButtonBack={handleClickBack}
        handleButtonNext={handleClickNext}
        disabledButtonNext={isNotAnyPrint(printsByChannel) || printIsLoading}
        categoryConfig={categoryConfig} />
      <ModalErrorFeature />
    </Wrapper>
  );
};
